/**
 * Application Routes
 * Centralized routing configuration
 * Following PROJECT_STRUCTURE_GUIDE.md pattern
 */

import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Layout from "../components/layout/Layout";
import JobDetails from "../components/jobDetails/JobDetails";
import LandingPage from "../components/landingPage/LandingPage";
import QuestionsList from "../components/questionsList/QuestionsList";
import Sections from "../components/sections/Sections";
import SectionDetails from "../components/sectionDetails/SectionDetails";
import SignIn from "../components/signIn/SignIn";
import UploadJobs from "../components/uploadJobs/UploadJobs";
import UpdateQuestions from "../components/updateQuestions/UpdateQuestions";
import UpdatedQuestionsLandingPage from "../components/updatedQuestionsLandingPage/UpdatedQuestionsLandingPage";
import UsersList from "../components/users/UsersList";
import PreviewQuestionsLanding from "../components/previewQuestions/PreviewQuestionsLanding";
import Lookup from "../components/previewQuestions/Lookup";
import PreviewQuestionsResults from "../components/previewQuestions/PreviewQuestionsResults";
import ReportsMenu from "../components/reportsMenu/ReportsMenu";
import PublishedQuestionsReport from "../components/reports/PublishedQuestionsReport";
import { PrivateRoute } from "../guards/PrivateRoute";
import { RoleBasedRoute } from "../guards/RoleBasedRoute";
import { UploadJobsRoute } from "../guards/UploadJobsRoute";

const AppRoutes = () => {
  useLocation();

  return (
    <div className="globalWrapper">
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={
          <Layout showHeader={false}>
            <SignIn />
          </Layout>
        } />

        {/* Protected Routes with Layout */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout showFooter={true}>
                <LandingPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/upload-jobs"
          element={
            <UploadJobsRoute>
              <Layout>
                <UploadJobs />
              </Layout>
            </UploadJobsRoute>
          }
        />
          <Route
          path="/update-jobs"
          element={
            <UploadJobsRoute>
              <Layout>
                <UpdateQuestions />
              </Layout>
            </UploadJobsRoute>
          }
        />
        <Route
          path="/questions/update"
           element={
            <PrivateRoute>
              <Layout>
                <UpdatedQuestionsLandingPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/jobs/:jobId"
          element={
            <PrivateRoute>
              <Layout>
                <JobDetails />
              </Layout>
            </PrivateRoute>
          }
        />
         <Route
          path="/questions/update/:jobId"
          element={
            <PrivateRoute>
              <Layout>
                <JobDetails />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/questions/:jobId"
          element={
            <PrivateRoute>
              <Layout>
                <QuestionsList />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/questions/update/questions/:jobId"
          element={
            <PrivateRoute>
              <Layout>
                <QuestionsList />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/sections"
          element={
            <RoleBasedRoute requiredPermission={(p) => p.canViewSections}>
              <Layout>
                <Sections />
              </Layout>
            </RoleBasedRoute>
          }
        />
        <Route
          path="/sections/:sectionId"
          element={
            <RoleBasedRoute requiredPermission={(p) => p.canViewSections}>
              <Layout>
                <SectionDetails />
              </Layout>
            </RoleBasedRoute>
          }
        />

        {/* Users Management Routes */}
        <Route
          path="/users"
          element={
            <RoleBasedRoute requiredPermission={(p) => p.canViewUsers}>
              <Layout>
                <UsersList />
              </Layout>
            </RoleBasedRoute>
          }
        />

        {/* Preview Questions Routes */}
        <Route
          path="/questions/preview"
          element={
            <PrivateRoute>
              <Layout>
                <PreviewQuestionsLanding />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/questions/lookup"
          element={
            <PrivateRoute>
              <Layout>
                <Lookup />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/preview-questions/results"
          element={
            <PrivateRoute>
              <Layout showFooter={false}>
                <PreviewQuestionsResults />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/preview-questions/results/:questionId"
          element={
            <PrivateRoute>
              <Layout showFooter={false}>
                <PreviewQuestionsResults />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Reports Routes */}
        <Route
          path="/reports"
          element={
            <PrivateRoute>
              <Layout>
                <ReportsMenu />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/reports/published-questions"
          element={
            <PrivateRoute>
              <Layout>
                <PublishedQuestionsReport />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Fallback route */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </div>
  );
};

export default AppRoutes;
